// extracted by mini-css-extract-plugin
module.exports = {"list":"_8c559fa4c7--list--m47qr","item":"_8c559fa4c7--item--D4JxZ"};